<template>
    <li class="subBet notranslate">
        <div class="subBet-info">
            <div class="subBet-option">
                <span v-if="isShowLiveScore" data-testid="bet-builder-selection-score">[{{ liveScoreDisplay }}] </span>
                <span>{{ selection.market.marketType.name }}</span>
                <span class="separator">|</span>
                <strong>{{ optionName }}</strong>
                <strong v-if="point" class="oddsPoint">{{ point }}</strong>
            </div>
        </div>
    </li>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import { getMarketRule } from '@/components/oddsDisplay/moreMarket/betBuilderMarketRules';
    import { getBetBuilderLiveScoreDisplay, getBetTypeGroup } from '@/core/lib/betBuilderHelper';
    import { formatPointAsRange, isBetBuilderHandicap, isBetBuilderOU } from '@/core/lib/oddsHelper';
    import type { IEvent } from '@/interface/IEvent';
    import type { IBetBuilderCombinationSelection } from '@/interface/betBuilder';
    import { BetTypeGroup } from '@/interface/enum';

    const props = defineProps<{
        selection: IBetBuilderCombinationSelection;
        event: IEvent;
    }>();

    const point = computed(() => {
        const { displayType, point } = props.selection.market;
        if (!isBetBuilderHandicap(displayType) && !isBetBuilderOU(displayType)) {
            return '';
        }
        return formatPointAsRange(point);
    });

    const optionName = computed(() => {
        const rule = getMarketRule(props.selection.market);
        return rule.optionFormatter({
            market: props.selection.market,
            selection: props.selection,
        });
    });

    const liveScoreDisplay = computed(() => getBetBuilderLiveScoreDisplay(props.event, props.selection.market.marketType.id));

    const isShowLiveScore = computed(() => !!liveScoreDisplay.value
        && getBetTypeGroup(props.selection.market.marketType.id) !== BetTypeGroup.Main);
</script>

<style lang="scss" scoped>
    @import "@/components/mpRecommendation/MpCombinationSubBet";
    @import "@/components/betBuilderRecommendation/BetBuilderRecommendation";
</style>
